<template>
  <div class="container">
    <MoviesStep id="moviesStep" @choose-movie="onChooseMovie" />

    <CinemaStep
      v-if="store.bookingProgress.step >= 1"
      id="cinemaStep"
      :key="keyCinema"
      :show-cinema-offline-alert="showCinemaOfflineAlert"
      :class="{
        'p-booking__cinema-step': !Object.keys(
          store.bookingProgress.selectedCinema
        ).length,
      }"
      @choose-cinema="chooseCinema"
      @choose-city="chooseCity" />
    <DateScreenStep
      v-if="store.bookingProgress.step >= 2"
      id="dateStep"
      :key="keyDate" />
  </div>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import CinemaStep from '../../components/Booking/Step1/CinemaStep.vue'
import DateScreenStep from '../../components/Booking/Step1/DateScreenStep.vue'
import MoviesStep from '../../components/Booking/Step1/MoviesStep.vue'
import { useBookingStore } from '../../store/BookingStore'
import { getLocale } from '../../../lib/lib'
import { getFormattedDate } from '../../../lib/date'
import { useRoute } from 'vue-router'
import { v4 as uuidv4 } from 'uuid'

const route = useRoute()
const store = useBookingStore()
const showCinemaOfflineAlert = ref(false)
const keyCinema = ref()
const keyDate = ref()

onMounted(() => {
  // these methods should BE with this order
  chooseCinemaByRoute()
  chooseDateByRoute()
  nextTick(() => {
    chooseScreenByRoute()
  })
})

const onChooseMovie = () => {
  keyCinema.value = uuidv4()
}

const chooseCinema = () => {
  keyDate.value = uuidv4()
}

const chooseCity = () => {
  reselectMovie()
}

const reselectMovie = () => {
  store.selectMovie(store.bookingProgress.selectedMovie)
}

const chooseCinemaByRoute = () => {
  const cinemaId = route.query.cinemaId

  if (!cinemaId) {
    return
  }

  const entry = store.getAllCinemas.find((i) => i.value === cinemaId)

  if (!entry) {
    return
  }

  if (!entry.isOnline) {
    showCinemaOfflineAlert.value = true
    return
  }

  store.selectCinema(entry)
}

const chooseDateByRoute = () => {
  const date = route.query.date

  if (date) {
    const entry = store.allFilters.dates.find((i) => i.value === date)

    if (entry) {
      store.selectDate({
        dateValue: date,
        fullDate: getFormattedDate(entry.display),
        formattedDate: getFormattedDate(entry.display, getLocale(), {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
        }),
      })
    }
  }
}

const chooseScreenByRoute = () => {
  const screen = route.query.screen

  if (screen) {
    const screenData = store.getAllCinemaScreens.find((i) => i.id === screen)

    store.selectRoom(screenData)
    clickNextStepToTickets()
  }
}

const clickNextStepToTickets = () => {
  nextTick(() => {
    const nextBtn = document.getElementById('nextStepBtn')
    if (nextBtn) {
      nextBtn.click()
    }
  })
}
</script>
